import {
  userSettingSchema,
  UserSettingSchema,
} from '@soniq/schema-connection'
import { HttpReadWriteStore } from '@soniq/public-resource'

export class UserSettingStore extends HttpReadWriteStore<UserSettingSchema> {
  static new() {
    return new UserSettingStore(
      'user_setting',
      userSettingSchema.validateFn
    )
  }
}
